import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type ViewRange = 'month' | 'week' | 'list' | 'stays';

type DateUnit = 'month' | 'week';

export const VIEW_MAPPINGS: Record<ViewRange, DateUnit> = {
  month: 'month',
  week: 'week',
  list: 'month',
  stays: 'month',
};

const useFormatDateRange = ({
  date,
  rangeType,
  compact,
}: {
  date: Dayjs;
  rangeType: ViewRange;
  compact: boolean;
}) => {
  const [formattedDate, setFormattedDate] = useState('');
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLocale = i18n.language.toLowerCase();
    dayjs.locale(currentLocale);

    if (rangeType === 'week') {
      const startOfWeek = date.locale(currentLocale).startOf('week');
      const endOfWeek = startOfWeek.add(6, 'day');

      if (startOfWeek.month() === endOfWeek.month()) {
        setFormattedDate(
          `${startOfWeek.locale(i18n.language).format('D')} – ${endOfWeek.locale(i18n.language).format(compact ? 'D MMM' : 'D MMM YYYY')}`
        );
      } else {
        if (startOfWeek.year() === endOfWeek.year()) {
          setFormattedDate(
            `${startOfWeek.locale(i18n.language).format('D MMM')} – ${endOfWeek.locale(i18n.language).format(compact ? 'D MMM' : 'D MMM YYYY')}`
          );
        } else {
          setFormattedDate(
            `${startOfWeek.locale(i18n.language).format(compact ? 'D MMM' : 'D MMM YYYY')} – ${endOfWeek.locale(i18n.language).format(compact ? 'D MMM' : 'D MMM YYYY')}`
          );
        }
      }
      return;
    }

    setFormattedDate(date.locale(i18n.language).format('MMMM YYYY'));
  }, [compact, date, i18n.language, rangeType]);

  return formattedDate;
};

export default useFormatDateRange;
